import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const rub = (v) => `${Number(v || 0).toLocaleString("ru-RU", { maximumFractionDigits: 2 })} ₽`;

// П.11 TZ-6: сводка дня по возвратам; клик по сбоям — фильтр «Сбои»
export const RefundsSummaryBar = ({ summary, onFailedClick }) => {
  if (!summary) return null;
  return (
    <div data-testid="refunds-summary-bar" className="mb-3 px-3 py-2 rounded-lg text-sm flex flex-wrap items-center gap-x-2 gap-y-1"
      style={{ background: "#F8FAFC", border: "1px solid var(--rv-border)", color: "var(--rv-text-primary)" }}>
      <span>Сегодня ({summary.date_msk}, MSK): возвращено</span>
      <strong data-testid="refunds-summary-amount">{rub(summary.returned_amount)}</strong>
      <span data-testid="refunds-summary-count">({summary.returned_count} шт.)</span>
      <span>· в обработке <strong data-testid="refunds-summary-pending">{summary.pending}</strong></span>
      <span>·</span>
      <button type="button" onClick={onFailedClick} data-testid="refunds-summary-failed-btn" className="underline underline-offset-2 font-semibold"
        style={{ color: summary.failed ? "var(--rv-error)" : "var(--rv-text-secondary)", background: "none", border: "none", cursor: "pointer", padding: 0 }}>
        сбоев {summary.failed}
      </button>
    </div>
  );
};

// П.3 TZ-6: тумблер владельца auto_refund_on_expiry (по умолчанию выключен)
export const AutoRefundOnExpiryToggle = ({ showToast }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/deadline-settings`).then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;
  const toggle = async () => {
    const next = !cfg.auto_refund_on_expiry;
    if (next && !window.confirm(`Включить ночной авто-возврат? Задания, замороженные после ${cfg.grace_days} дней без решения заказчика, будут отменяться с возвратом автоматически.`)) return;
    try {
      const r = await axios.put(`${API}/admin/deadline-settings`, { auto_refund_on_expiry: next });
      setCfg(r.data);
      showToast && showToast(next ? "Авто-возврат по истечении срока включён" : "Авто-возврат по истечении срока выключен", "success");
    } catch (e) { showToast && showToast(e.response?.data?.detail || "Не удалось сохранить", "error"); }
  };
  return (
    <label className="mb-3 flex items-center gap-2 text-xs" style={{ color: "var(--rv-text-secondary)" }} data-testid="auto-refund-on-expiry-setting">
      <input type="checkbox" checked={!!cfg.auto_refund_on_expiry} onChange={toggle} data-testid="auto-refund-on-expiry-toggle" style={{ accentColor: "var(--rv-teal)" }} />
      Авто-возврат по истечении срока (после {cfg.grace_days} дней заморозки, ежечасная проверка) — {cfg.auto_refund_on_expiry ? "включён" : "выключен"}
    </label>
  );
};
